import { signal, Signal, batch, ReadonlySignal } from "@preact/signals";

export type Rating = 'hate' | 'confused' | 'neutral' | 'happy' | 'excited' | 'initial';

export type IRatingbarStateType = {
  rating: Signal<Rating>
}

export type ICreateRatingbarStateReturn = {
  ratingbar: ReadonlySignal<IRatingbarStateType>;
  resetRatingbarState: () => void;
}

const defaultUserValues: IRatingbarStateType = {
  rating: signal('initial'),
}

const createRatingbarState = (): ICreateRatingbarStateReturn => {
  const ratingbar = signal<IRatingbarStateType>(defaultUserValues);

  const resetRatingbarState = () => {
    batch(() => {
      ratingbar.value.rating.value = 'initial'
    })
  }

  return { ratingbar, resetRatingbarState }
}

export const RatingbarState = signal<ICreateRatingbarStateReturn>(createRatingbarState());

export default RatingbarState;
